import axios from 'axios';
import { environment } from '../../environment';

// #region usageTracker
/**
 * Tells the API whether someone is actually using the portal, so usage counts real use and not
 * a tab left open with background polling. Every request carries the current page and the seconds
 * since the last click, key, scroll or touch; while someone is active on a visible page and makes
 * no requests, a ping every minute keeps their session counted. Loaded once from index.tsx.
 */

const PING_MS = 60_000;
const ACTIVE_FOR_PING_S = 60;
let lastInput = Date.now();

const idleSeconds = (): number => Math.round((Date.now() - lastInput) / 1000);

const markInput = (): void => { lastInput = Date.now(); };
for (const event of ['pointerdown', 'keydown', 'scroll', 'touchstart', 'wheel']) {
    window.addEventListener(event, markInput, { passive: true, capture: true });
}
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') markInput(); });

// Only our own API: extra headers on S3 uploads or other services would break their CORS or signatures.
const apiOrigin = (() => { try { return new URL(environment.v2Url).origin; } catch { return ''; } })();
const isOurApi = (url: string | undefined, baseURL: string | undefined): boolean => {
    try { return !!apiOrigin && new URL(url ?? '', baseURL ?? window.location.href).origin === apiOrigin; } catch { return false; }
};

axios.interceptors.request.use((config) => {
    if (!isOurApi(config.url, config.baseURL)) return config;
    config.headers = config.headers ?? {};
    (config.headers as any)['X-Wallmates-Page'] = window.location.pathname;
    (config.headers as any)['X-Wallmates-Idle'] = String(idleSeconds());
    return config;
});

let lastRequest = 0;
axios.interceptors.request.use((config) => { lastRequest = Date.now(); return config; });

window.setInterval(() => {
    const token = localStorage.getItem('authToken');
    if (!token || document.visibilityState !== 'visible') return;
    if (idleSeconds() > ACTIVE_FOR_PING_S || Date.now() - lastRequest < PING_MS) return;
    void axios.post(`${environment.v2Url}/activity/ping`, {}, { headers: { 'X-Wallmates-Auth': token } }).catch(() => undefined);
}, PING_MS);

export {};
